/// <amd-module name="Wit/DeliveryPlans/Common/Services/IDeliveryPlansWorkItemService" />

import { IClientWorkItemService, IClientWorkItemUpdatedEvent } from "Wit/ClientWorkItemService/IClientWorkItemService";
import { IBoardFilterDataSource } from "Wit/Filter/FilterManager";
import { INamedFieldDataDictionary } from "Wit/WorkItemDataManager/Contracts";
import { IDeliveryPlansWorkItem, IIteration, IObservableDeliveryPlansWorkItem, ITeam } from "../Interfaces";

export type TopBottom = "top" | "bottom";

export type IWorkItemUpdatedEvent = IClientWorkItemUpdatedEvent<IDeliveryPlansWorkItem>;

export interface IDeliveryPlansWorkItemService extends IClientWorkItemService<IObservableDeliveryPlansWorkItem>, IBoardFilterDataSource {
    /**
     * Get the items that belong to a team.
     * @param team
     */
    getTeamItems(team: ITeam): IObservableDeliveryPlansWorkItem[];
    /**
     * Get the items that belong to an iteration. Items are returned in sorted order.
     * @param team
     * @param iteration
     */
    getIterationItems(team: ITeam, iteration: IIteration): IObservableDeliveryPlansWorkItem[];
    /**
     * Create a new work item.
     * @param projectId
     * @param workItemType
     * @param title
     * @param team
     * @param iteration
     * @param additionalFields
     * @param direction if the item should be placed at the top or bottom of the backlog
     */
    addNewWorkItem(
        projectId: string,
        workItemType: string,
        title: string,
        team: ITeam,
        iteration: IIteration,
        additionalFields: INamedFieldDataDictionary,
        direction: TopBottom
    ): Promise<void>;
    /**
     * Load a list of work items from the server and update any existing observable items
     * @param project project that the work items are in
     * @param workItemIds ids of the work items to be loaded
     * @param fieldReferenceNames fields to load for each work item
     */
    loadWorkItems(project: string, workItemIds: number[], fieldReferenceNames: string[]): Promise<void>;
    updateWorkItem(item: IDeliveryPlansWorkItem | number, fields: INamedFieldDataDictionary): Promise<void>;
    reorderInIterationToEnd(item: IObservableDeliveryPlansWorkItem, team: ITeam, direction: TopBottom): Promise<void>;
    openWorkItemDialog(workItemId: number, onSave?: (workItem: any) => void): void;
}
